import React from 'react';

class BasicSelect extends React.Component {
    constructor(props) {
        super(props);

        this.textStyle = {
            paddingRight: '5px'
        };
    }

    render() {
        return (
            <div style={{
                display: "flex",
                flexDirection: "horizontal",
                textAlign: "start",
            }}>
                <div style={this.textStyle}>{this.props.leadingText}</div>
                <select onChange={(val) => this.props.onChange(this.props.children[parseInt(val.target.value)], parseInt(val.target.value))} value={this.props.value}>
                    {this.props.children.map((child, index) => (
                        <option key={index} value={index}>{child} {this.props.afterText}</option>
                    ))}
                </select>
            </div>
        );
    }


}

export default BasicSelect;